import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { analyticsApi } from '@/api';

const PageTracker = () => {
  const location = useLocation();

  useEffect(() => {
    // Extract experience_id or guide_id from URL if present
    const pathParts = location.pathname.split('/');
    let experience_id = null;
    let guide_id = null;
    
    if (pathParts[1] === 'experience' && pathParts[2]) {
      experience_id = pathParts[2];
    } else if (pathParts[1] === 'explorer' && pathParts[2]) {
      guide_id = pathParts[2];
    }
    
    // Track the page view
    analyticsApi.trackPageView({
      page: location.pathname,
      experience_id,
      guide_id
    });
  }, [location.pathname]);

  return null; // This component doesn't render anything
};

export default PageTracker;
